import React, {Component, useEffect, useState} from 'react';
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import draftToHtml from 'draftjs-to-html';


interface TextEditorProps {
    HTMLvalueOnChangeCB: Function
    defaultValue: any

    // allow other unknown options
    [x: string | number | symbol]: unknown;
}

const TextEditor = ({HTMLvalueOnChangeCB, ...props}: TextEditorProps) => {
    const [editorState, setEditorState] = useState(EditorState.createEmpty())

    useEffect(() => {
        const HTMLvalue = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        HTMLvalueOnChangeCB(HTMLvalue)
    }, [editorState])

    useEffect(() => {
        if ("defaultValue" in props)
            setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(props["defaultValue"]))));
    }, [])
    return <div>
        <Editor
            {...props}
            editorState={editorState}
            wrapperClassName="wrapper-style"
            editorClassName="editor-style"
            toolbarClassName="toolbar-style"
            onEditorStateChange={setEditorState}
            toolbar={{
                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'emoji'],
            }}
        />

        {/*this line shows html value*/}
        {/*<textarea*/}
        {/*    disabled*/}
        {/*    value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}*/}
        {/*/>*/}

        {/*this line parse html and show the parsed html value*/}
        {/*<div dangerouslySetInnerHTML={{__html: draftToHtml(convertToRaw(editorState.getCurrentContent()))}}/>*/}
    </div>
}

export default TextEditor;